export const nameToKey = (name: string): string => name.toLowerCase().split(' ').join('-')

export const keyToName = (key: string): string =>
  key
    .split('-')
    .map((word) => word.slice(0, 1).toUpperCase() + word.slice(1))
    .join(' ')

export const getSeoToolUrl = (name: string): string => {
  if (name === SEO_TOOLS_NAMES.SONG_STRUCTURE_GENERATOR) return '/song-structure-template-generator-tool'
  if (name === SEO_TOOLS_NAMES.SONG_IDEAS_GENERATOR) return '/song-ideas-generator-tool'

  return `/${nameToKey(name)}`
}

export const getSeoToolIconUrl = (name: string): string => `/static/images/seo-tools/${nameToKey(name)}.png`

export const SEO_TOOLS_NAMES = {
  METRONOME: 'Online Metronome',
  CIRCLE_OF_FIFTHS: 'Circle of Fifths',
  CHORD_FINDER: 'Chord Finder',
  NOTE_FINDER: 'Note Finder',
  SCALE_FINDER: 'Scale Finder',
  PIANO_SCALES: 'Piano Scales',
  GUITAR_SCALES: 'Guitar Scales',
  SONG_STRUCTURE_GENERATOR: 'Song Structure Generator',
  SONG_IDEAS_GENERATOR: 'Song Ideas Generator',
  // BACKING_TRACK_GENERATOR: 'Backing Track Generator',
  DRUM_MACHINE: 'Drum Machine',
  PRINTABLE_STAFF_PAPER: 'Printable Staff Paper',
}

export const seoToolsLinks = Object.values(SEO_TOOLS_NAMES).map((st) => getSeoToolUrl(st))
